export type SubscriptionIntervalWeeks = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export type CustomerSubscriptionLineStatus = 0 | 1;

export type SubscriptionCycleRunStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const INTERVAL_WEEK_OPTIONS: ReadonlyArray<{
  value: SubscriptionIntervalWeeks;
  label: string;
}> = [
  { value: 1, label: 'Every 1 week' },
  { value: 2, label: 'Every 2 weeks' },
  { value: 3, label: 'Every 3 weeks' },
  { value: 4, label: 'Every 4 weeks' },
  { value: 5, label: 'Every 5 weeks' },
  { value: 6, label: 'Every 6 weeks' },
  { value: 7, label: 'Every 7 weeks' },
  { value: 8, label: 'Every 8 weeks' },
];

export const CYCLE_RUN_STATUS_LABELS: Record<SubscriptionCycleRunStatus, string> = {
  0: 'Scheduled',
  1: 'Processing',
  2: 'Order created',
  3: 'Payment succeeded',
  4: 'Payment failed',
  5: 'Skipped',
  6: 'Cancelled',
};

export interface StorefrontSubscriptionSettings {
  isSubscriptionEnabled: boolean;
  discountType: 0 | 1;
  discountValue: number;
}

export interface CustomerPaymentMethod {
  hasPaymentMethod: boolean;
  brand?: string | null;
  last4?: string | null;
  expMonth?: number | null;
  expYear?: number | null;
}

export interface CustomerSubscriptionLine {
  id: number;
  productCatalogId: number;
  productCatalogVariantId?: number | null;
  productName: string;
  quantity: number;
  unitPriceSnapshot: number;
  intervalWeeks: SubscriptionIntervalWeeks;
  status: CustomerSubscriptionLineStatus;
  nextRunDateUtc: string;
  lastRunDateUtc?: string | null;
  imageUrl?: string | null;
  recieverName?: string;
  recieverPhone1?: string;
  deliveryAddress?: string | null;
}

export interface SubscriptionLineHistoryItem {
  id: number;
  scheduledForUtc: string;
  status: SubscriptionCycleRunStatus;
  orderId?: number | null;
  errorMessage?: string | null;
  processedAtUtc?: string | null;
}

export interface AddSubscriptionLineRequest {
  productCatalogId: number;
  productCatalogVariantId?: number | null;
  quantity: number;
  intervalWeeks: SubscriptionIntervalWeeks;
  paidOrderId?: number | null;
}

export interface UpdateSubscriptionDeliveryAddressRequest {
  name: string;
  phone?: string;
  street1: string;
  street2?: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

export const PENDING_SUBSCRIPTION_STORAGE_KEY = 'hub-of-naturals:pending-subscription';

export interface PendingSubscriptionSelection {
  productCatalogId: number;
  productCatalogVariantId?: number | null;
  catalogSlug: string;
  productName: string;
  variantName?: string | null;
  imageUrl: string;
  unitPrice: number;
  quantity: number;
  intervalWeeks: SubscriptionIntervalWeeks;
  returnUrl: string;
}
